<template lang="pug">
  .container
    .heading-wrap
      h1.big-section-heading {{ $t('quote.heading') }}
      hr.typography-ruler
    .cards
      help-card
      quote-item-card(
        v-for='(item, index) in items',
        :item='item',
        :index='index',
        :key='item.id'
      )
      quote-upload-card
      additional-inputs
      disclaimer
    button.button.button--blue(:disabled='itemsLength <= 0', @click.prevent='sendQuoteRequest') {{ $t('quote.button') }}
</template>

<script>
import { mapGetters } from 'vuex'
import helpCard from '@/components/dashboard/help-card.vue'
import quoteUploadCard from '@/components/dashboard/quote-upload-card.vue'
import quoteItemCard from '@/components/dashboard/quote-item-card.vue'
import additionalInputs from '@/components/dashboard/additional-inputs.vue'
import disclaimer from '@/components/dashboard/disclaimer.vue'

export default {
  components: { helpCard, quoteUploadCard, quoteItemCard, additionalInputs, disclaimer },
  computed: {
    ...mapGetters('quote', ['items', 'itemsLength'])
  },
  methods: {
    async sendQuoteRequest () {
      this.$ga.event('Button', 'Clicked', `Get a quote ${this.$i18n.locale.toUpperCase()}`)
      try {
        await this.$store.dispatch('quote/sendQuoteRequest')
        this.$store.dispatch('quote/resetAll')
        this.$store.dispatch('quote/resetQuoteId')
        this.$ga.event('Quote', 'Success', 'Successful Quote')
        if (typeof gtag !== 'undefined') {
          window.gtag('event', 'conversion', { send_to: 'AW-1030198831/Au7dCMqX-mgQr6ye6wM' })
        }
        this.$notify({ group: 'general', type: 'success', title: 'Success', text: this.$t('quote.successMessage'), duration: -1 })
      } catch (error) {
        console.error(error)
        this.$ga.event('Quote', 'Error', error.message)
        this.$notify({ group: 'general', type: error.type || 'error', title: error.title, text: error.message, duration: -1 })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/abstract/variables.scss';

  .heading-wrap {
    margin: 3em auto;
    max-width: 570px;
    text-align: center;
    color: $blue;
  }

  .typography-ruler {
    margin: 3em auto;
  }

  .button {
    margin: 0 auto;
    display: block;
  }

  .cards {

    max-width: 90%;
    width: 100%;
    margin: 0 auto;

    * + * {
      margin-top: 2em;
    }
  }
</style>
